import { asRecord } from "./ToolResultView.utils";
import { text, titleCase } from "./ToolResultView.utils";

export { text, titleCase };

export function recordValue(value: unknown) {
  return asRecord(value) ?? {};
}
export function payload(result: unknown) {
  const value = asRecord(result);
  return value && "output" in value ? value.output : result;
}
export function shellOutput(result: unknown) {
  const value = asRecord(result);
  return (
    text(value?.output) ||
    text(value?.stdout) ||
    (typeof result === "string" ? result : "")
  );
}
export function pathsFrom(result: unknown) {
  const raw = payload(result);
  if (Array.isArray(raw))
    return raw
      .map((item) => text(item) || text(asRecord(item)?.path))
      .filter(Boolean);
  const record = asRecord(raw);
  for (const key of ["paths", "entries", "files", "matches", "results"]) {
    if (Array.isArray(record?.[key])) {
      return record[key]
        .map((item) => {
          const value = asRecord(item);
          return value
            ? text(value.path) || text(value.file) || text(value.name)
            : text(item);
        })
        .filter(Boolean);
    }
  }
  return shellOutput(result)
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
}
